import React from 'react';
import PropTypes from 'prop-types';

import Spinner from './Loading.styles';

const Loading = ({ transparentBg, fullHeight, extraClassNames }) => (
  <div className={`${fullHeight ? 'h-full' : 'h-screen-60'} relative  w-full ${extraClassNames}`}>
    <div className={`${transparentBg ? 'bg-transparent' : 'bg-white'} h-full w-full`} />
    <Spinner
      role="status"
      className={`absolute inline-block w-8 h-8 align-text-bottom rounded-full border-4 inset-1/2 ${
        transparentBg ? 'border-secondary-300' : 'border-secondary'
      }`}
    />
    <span className="sr-only">Loading...</span>
  </div>
);

Loading.defaultProps = {
  transparentBg: false,
  fullHeight: false,
  extraClassNames: '',
};

Loading.propTypes = {
  transparentBg: PropTypes.bool,
  fullHeight: PropTypes.bool,
  extraClassNames: PropTypes.string,
};

export default Loading;
